import { render } from "./GaiKuang.vue?vue&type=template&id=7b50952c&scoped=true"
import script from "./GaiKuang.vue?vue&type=script&lang=js"
export * from "./GaiKuang.vue?vue&type=script&lang=js"

import "./GaiKuang.vue?vue&type=style&index=0&id=7b50952c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b50952c"]])

export default __exports__